import axios from "axios";
import { getOperateCityAreaList } from "@/api/common";
import { Message, Notification } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import {
  getCityPage,
  byCityGetArea,
  baseAreaList,
} from "@/api/Advertisement/AdvertisingSpace";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true,因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在,重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * 导出excel
 * 由于前期名字设计的原因
 * 该函数可以用于导出多种不同类型的文件  具体的响应类型可以在该函数的blobTypes中设置
 *
 * @param {Object} {  }
 * @returns
 */
export async function exportExcel(
  config,
  fileName = "download",
  type = "excel"
) {
  console.log(store);
  // 二进制文件的blob对应类型
  const blobTypes = {
    excel: "application/vnd.ms-excel;charset=utf-8",
    zip: "application/zip"
  };
  const { url: path } = config;

  // 每次下载触发的事件
  const onDownloadProgress = progressEvent => {
    // console.log(progressEvent)
    // 当前下载的响应信息
    const { readyState, response } = progressEvent.currentTarget;
    const loaded = progressEvent.loaded;
    // console.log(readyState)
    // if (readyState === 3) {
    //   // 当前下载的文件大小
    //   store.dispatch('XNotification/setDown', {
    //     path, // 请求下载的接口路径
    //     fileName, // 文件名
    //     loaded // 当前下载的文件大小
    //   })
    // } else if (readyState === 4) {
    //   const done = loaded >= response.size
    //   // 当前下载的文件大小
    //   store.dispatch('XNotification/setDown', {
    //     path, // 请求下载的接口路径
    //     fileName, // 文件名
    //     loaded, // 当前下载的文件大小,
    //     size: response.size, // 要下载的文件总大小
    //     done, // 是否下载完成
    //     doneTime: done ? Date.now() : ''
    //   })
    // }
  };
  // 请求的基本配置
  const baseConfig = {
    baseURL: process.env.VUE_APP_BASE_API
    // timeout: 1000 * 60
    // onDownloadProgress
  };
  console.log(baseConfig);
  let headers = {}; // 信息头对象
  try {
    // 获取token 将token作为头信息进行请求
    headers = { Authorization: getToken() };
    // baseConfig = { ...baseConfig, headers }
  } catch (error) {
    // 如果这里报错 说明是没有获取到token
    Message({
      type: "error",
      message: error // message: '请求登录后重试!'
    });
    return;
  }

  // // 先创建一个vuex任务 在下载列表中显示
  // store.dispatch('XNotification/setDown', {
  //   path, // 请求下载的接口路径
  //   fileName, // 文件名
  //   done: false
  // })

  // // 在vuex中查找是否重复导出
  // const findDown = store.state.XNotification.downs.find(
  //   item => item.path === config.url
  // )
  // // 如果是下载中 就直接退出
  // if (findDown && findDown.done) {
  //   return Message({
  //     message: '该导出任务已经在导出队列, 请稍后重试',
  //     error: 'warning'
  //   })
  // }

  try {
    // 合并基础的配置和传过来的请求配置 进行发送请求
    const { data } = await axios({
      ...baseConfig,
      ...config,
      headers
    });

    // 设置请求过来的blob类型的数据 设置类型
    const blob = new Blob([data], {
      type: blobTypes[type]
    });
    mockDownFile(blob, fileName); // 模拟浏览器下载文件
  } catch (e) {
    console.error(e);
    Message({
      message: e,
      type: "error",
      duration: 5 * 1000
    });
  }
}

/**
 * 获取区域的定位
 * @param {Object} selectAreaObj
 * @returns {lat,lng}
 */

export async function getAreaPositions(selectArea) {
  console.log(selectArea);
  if (!selectArea.hasOwnProperty("areaCode")) {
    Message({
      message: "请选择到区域！",
      type: "error"
    });
    return;
  }

  // 获取和城市编码和区域编码
  const { cityCode, areaCode } = selectArea;
  // 根据城市编码获取区域编码
  const { data } = await baseAreaList(cityCode);
  // 在返回的对象中 获取坐标
  const { lat, lng } = data.find(item => item.areaCode === areaCode);
  // 赋值定位中心的坐标的对象
  return {
    lat,
    lng
  };
}
/**
 * 获取每个月有多少天
 * @param {number} year  格式2021
 * @param {number} month month是真实月份减1 前面不带0
 */
export function getDays(year, month) {
  if (!year) {
    // 没传年份默认获取当前月份天数
    var curDate = new Date();
    year = curDate.getFullYear();
    month = curDate.getMonth();
  }
  const days = [31, 28, 31, 30, 31, 30, 31, 30, 30, 31, 30, 31]; // 各个月份对应天数数组
  if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
    // 计算是否是闰年修改二月天数
    days[1] = 29;
  }
  return days[month]; // 返回对应月份天数
}
/**
 * 获取一个月横坐标日期数组 格式['5-1','5-2']
 * @param {number} month month是真实月份 前面不带0
 * @param {number} day  对应月份天数
 */
export function getXDataArray(month, day) {
  const xDataArray = [];
  for (let i = 1; i <= day; i++) {
    xDataArray.push(month + "-" + i.toString().padStart(2, "0"));
  }
  return xDataArray;
}

/**
 * 根据图片url 返回url的blob对象
 * (使用场景:编辑已经上传过的图片 要操作图片文件对象 就需要这个函数去请求对应已经上传到服务器的图片路径 获取对应的blob对象)
 * @param {string} url
 * return { blob } iamge file blob
 */
export async function byImgUrlGetMockImageObj(url = "") {
  // url验证 是否存在 是否不为null 是否http开头
  if (!url || url == null) {
    return;
  }
  if (url.indexOf("https") == -1) {
    url = url.replace("http", "https");
  }
  // url ? (url = `http${url.split('https')[1]}`) : null // 将https协议转成http
  console.log(url);
  // 发送请求 并获取blob数据
  const { data: blob } = await axios({
    method: "get",
    url,
    header: {
      Accept: "image/jpg"
    },
    responseType: "blob"
  });
  // 根据blob数据 生成文件的file文件对象并返回
  // return new File([blob], 'image', {type: 'image/jpg'})
  // return new Blob([blob], { type: 'image/jpg' })
  // return {
  //   blob,
  //   file: new File([blob], 'image', {type: 'image/jpg'})
  // }
  const file = new File([blob], "image", {
    type: "image/jpg"
  });
  const blobUrl = URL.createObjectURL(blob); // 将blob对象生成一个blob路径
  // 返回 一个可以被element-ui 的upload组件识别的模拟对象
  return {
    raw: file,
    url: blobUrl
  };
}
// 格式化数字成金额（123456789--->>￥123,456,789.00）
export function formatNum(str, type = 1) {
  const flg = str ?? "donthave";
  if (flg == "donthave") return "暂无";
  str = str + "";
  // 若是整数自动补全小数位
  if (str.indexOf(".") == -1) {
    str = str + ".00";
  }
  // 全部替换
  if (str.indexOf(",") != -1) {
    str = str.replace(new RegExp(",", "g"), "");
  }
  const intSum = str
    .substring(0, str.indexOf("."))
    .replace(/\B(?=(?:\d{3})+$)/g, ","); // 取到整数部分
  const dot = str.substring(str.length, str.indexOf(".")); // 取到小数部分搜索
  if (type == 1) {
    const ret = "￥" + intSum + dot;
    return ret;
  } else if (type == 2) {
    const ret = intSum + dot;
    return ret;
  }
}

/**
 * 解析时间并赋值对象
 * @param {String} time 时间
 * @param {Object} updateObj 指针 要修改的对象
 * @param {String} key 键值
 */
export const parseTimeAndAssignment = (time, updateObj, key) =>
  (updateObj[key] = parseTime(time));

/**
 * dataUrl转成Blob
 * @param {*} dataUrl
 * @returns
 */
export const dataUrlToBlob = dataUrl => {
  let [mine, base64Data] = dataUrl.split(",");
  mine = mine.match(/:(.*?);/)[1];
  const parseData = window.atob(base64Data);
  let len = parseData.length;
  const u8arr = new Uint8Array(len);
  while (len--) {
    u8arr[len] = parseData.charCodeAt(len);
  }
  return new Blob([u8arr], { type: mine });
};

/**
 * 下载DataUrl
 * @param {*} dataUrl
 * @param {*} fileName
 */
export const downDataUrl = (dataUrl, fileName) => {
  mockDownFile(dataUrlToBlob(dataUrl), fileName);
};

/**
 * 模拟浏览器下载文件
 * @param {*} blob
 * @param {*} fileName
 */
export const mockDownFile = (blob, fileName) => {
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = URL.createObjectURL(blob); // 利用URL的创建对象 将blob对象 生成一个对象url
  link.download = fileName; // 文件名称
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // 移除元素
  window.URL.revokeObjectURL(link.href); // 释放blob对象
};

let debounce2Timer = null;

export const debounce2 = (fn, daley = 1000) => {
  return function(...args) {
    if (debounce2Timer) {
      clearTimeout(debounce2Timer);
    }
    debounce2Timer = setTimeout(() => fn.apply(this, args), daley);
  };
};

export const dateStamp2dateTimeText = timeStamp => {
  const fillStart = str => str.toString().padStart(2, "0");
  const dateObj = new Date(timeStamp);
  const dateStr = [
    dateObj.getFullYear(),
    dateObj.getMonth() + 1,
    dateObj.getDate()
  ]
    .map(fillStart)
    .join("-");
  const timeStr = [
    dateObj.getHours(),
    dateObj.getMinutes() + 1,
    dateObj.getSeconds()
  ]
    .map(fillStart)
    .join(":");
  return `${dateStr} ${timeStr}`;
};

function test(type, value, msgText) {
  let reg;
  let status = true;
  switch (type) {
    case 'numbersGreater':
      reg=/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/
      status = reg.test(value);
      break
    case "plateNo":
      reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[A-Z])|([A-Z]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
      status = reg.test(value);
      break;
    case "mobile":
      reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      status = reg.test(value);
      break;
    case "number":
      status = typeof value === "number" && !isNaN(value);
      break;
    case "email":
      reg = /^[A-Za-z0-9\-_]+[A-Za-z0-9\.\-_]*[A-Za-z0-9\-_]+@[A-Za-z0-9]+[A-Za-z0-9\.\-_]*(\.[A-Za-z0-9\.\-_]+)*[A-Za-z0-9]+\.[A-Za-z0-9]+[A-Za-z0-9\.\-_]*[A-Za-z0-9]+$/;
      status = reg.test(value);
      break;
    case "password":
      reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/;
      status = reg.test(value);
      break;
    case "empty":
      if (typeof value === "string") {
        value = value.trim();
      }
      if (value === "" || value == null || typeof value === undefined||value.length==0) {
        status = false;
      }
      break;
    case "ip":
      reg = /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[0-9])\.((1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){2}(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/;
      status = reg.test(value);
      break;
    case "port":
      reg = /^[1-9]\d*$/.test(value) && 1 <= 1 * value && 1 * value <= 65535;
      status = !reg ? false : true;
      break;
    case "integer":
      reg = /^[1-9]\d*$/
      status =  reg.test(value);
      break
  }
  if (!status) {
    Message({
      type: "warning",
      message: msgText
    });
  }
  return status;
}
window.formatAll = test;
